import { SUBSCRIBED_EMAIL, UNSUBSCRIBED_EMAIL, UNSUBSCRIBED_EMAIL_FAILED, UNSUBSCRIBED_EMAIL_SUCCESS } from "./actionTypes"

const initialState = {
    unAuthPageLoder: false,
    unsubscribedEmailSuccess: null,
    unsubscribedEmailFailed: null
}

const nonAuthenticatepagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case UNSUBSCRIBED_EMAIL:
            return {
                ...state,
                unAuthPageLoder: true,
                unsubscribedEmailSuccess: null,
                unsubscribedEmailFailed: null
            }
        case UNSUBSCRIBED_EMAIL_SUCCESS:
            return {
                ...state,
                unAuthPageLoder: false,
                unsubscribedEmailSuccess: action.payload,
                unsubscribedEmailFailed: null
            }
        case UNSUBSCRIBED_EMAIL_FAILED:
            return {
                ...state,
                unAuthPageLoder: false,
                unsubscribedEmailSuccess: null,
                unsubscribedEmailFailed: action.payload
            }

        case SUBSCRIBED_EMAIL:
            return {
                ...state,
                unAuthPageLoder: true,
                unsubscribedEmailSuccess: null,
                unsubscribedEmailFailed: null
            }
        default:
            return state
    }
}

export default nonAuthenticatepagesReducer
